export function requestedRepos(input: {
  repoFullName?: string;
  repoFullNames?: string[];
}): string[] {
  const seen = new Set<string>();
  const names: string[] = [];
  for (const raw of [input.repoFullName, ...(input.repoFullNames ?? [])]) {
    const name = raw?.trim();
    if (!name || seen.has(name.toLowerCase())) continue;
    seen.add(name.toLowerCase());
    names.push(name);
  }
  return names;
}
